import React from "react";
import Helmet from "react-helmet";

import Navigation from "../../components/WaveNavigation";
import ImagePlaceholder from "../../components/ImagePlaceholder";

import "./media.scss";

import fairHarbor from "../../assets/img/explore/fair-harbor-hero.jpg";
import waterTaxi from "../../assets/img/explore/water-taxi.png";
import saltaire from "../../assets/img/explore/saltaire-hero.jpg";
import lighthouse from "../../assets/img/explore/lighthouse.jpg";
import oceanBayPark from "../../assets/img/explore/ocean-bay-park-hero.jpg";
import waterTaxi2 from "../../assets/img/explore/water-taxi-2.png";
import atlantique from "../../assets/img/explore/atlantique-hero.jpg";
import seaview from "../../assets/img/explore/seaview-hero.jpg";

// Placeholder gallery using existing site photography until production stills
// are supplied. Swap `src` values for real media images when available.
const REEL_FRAMES = [
  { src: fairHarbor, label: "Fair Harbor waterfront" },
  { src: waterTaxi, label: "Fire Island Water Taxi" },
  { src: saltaire, label: "Saltaire waterfront" },
  { src: lighthouse, label: "Fire Island Lighthouse" },
  { src: oceanBayPark, label: "Ocean Bay Park" },
  { src: waterTaxi2, label: "Water taxi on the bay" },
  { src: atlantique, label: "Atlantique waterfront" },
  { src: seaview, label: "Seaview waterfront" },
];

const MediaReel = () => {
  const frames = [...REEL_FRAMES, ...REEL_FRAMES];

  return (
    <section className="media-reel-wrap" aria-label="Production stills">
      <div className="media-reel">
        <div className="media-reel-viewport">
          <div className="media-reel-track">
            {frames.map((frame, index) => (
              <div
                className="media-reel-frame"
                key={`${frame.label}-${index}`}
              >
                <ImagePlaceholder
                  src={frame.src}
                  label={frame.label}
                  alt={frame.label}
                  rounded={false}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default () => (
  <div>
    <Helmet
      title="Fire Island Ferries | Media Inquiries"
      meta={[
        {
          name: "description",
          content:
            "Film, television, and print production inquiries for Fire Island Ferries and Fire Island Water Taxis.",
        },
        {
          name: "keywords",
          content:
            "Fire Island, film production, media, television, location scouting, ferries, water taxi",
        },
      ]}
    />
    <Navigation />
    <MediaReel />
    <div className="container page">
      <div className="heading">
        <h2>Info</h2>
        <h1>Media Inquiries</h1>
      </div>
      <p>
        Scouting for a premier production basecamp with a unique film-friendly
        location?
      </p>
      <p>
        Fire Island Ferries, Inc. and Fire Island Water Taxis, LLC have been in
        numerous film, television, and print productions.
      </p>
      <p>
        We provide scenic waterfront views, simplistic terminal spaces with ample
        parking and load-in space, and private access to our outstanding ferries
        and water taxis, which allows production teams to create dynamic media
        opportunities.
      </p>
      <p>All production pricing is reviewed on a case-by-case basis.</p>
      <p>
        Send all inquiries to{" "}
        <span className="text-nowrap">
          <i className="far fa-envelope" />{" "}
          <a href="mailto:media@fireislandferries.com">
            media@fireislandferries.com
          </a>
        </span>
        . Allow for 3–5 business days for a reply.
      </p>
      <p>Please provide the following:</p>
      <ul className="media-inquiry-list">
        <li>Name and contact information</li>
        <li>Affiliated company and/or project</li>
        <li>Approximate timeline for production</li>
        <li>Approximate size of the production (equipment and personnel)</li>
      </ul>
    </div>
  </div>
);
